import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import './App.css';

// ============================================================
// PERSONALISIERUNG – HIER ANPASSEN!
// ============================================================
const CONFIG = {
  name: "Sivani",
  date: "09. März 2026",

  loveLetterLines: [
    "Hooiii min Pinguuu,",
    "",
    "Es isch sooo Crazy scho sind 3 jahre vergange und wir werdet scho hüürate HEHE",
    "Ich bi huuuuere de glücklspilz das wir üs gfunde hand. ❤️",
    "",
    "Ich freu mich scho uf ganz viel jahre mit dir ",
    "Du machsch mich glücklich idiot",
    "",
    "ich ha en chlini gschenk für dich",
    "Bist ready ? 🎁",
  ],

  // TODO: PASSE DIESE 3 FRAGEN AN!
  // correct = Index der richtigen Antwort (0 = erste, 1 = zweite, ...)
  quizQuestions: [
    {
      emoji: "🌍",
      question: "Wo haben wir uns zum ersten Mal getroffen?",
      options: ["Siyan hochzeit", "Vietnam", "Sushi essen", "Tamilschool"],
      correct: 2,
    },
    {
      emoji: "🍽️",
      question: "Was ist mein absolutes Lieblingsessen?",
      options: ["Steak", "Ramen", "Sushi", "Dönner"],
      correct: 0,
    },
      {
        emoji: "🥺",
        question: "Wie bring ich dich am beste abe wen hässig bisch ?",
        options: ["dumm tue und \"Sorry\" sege", "Dir was esse bringe \"ohni zfrage\"", "Dich küsse oder umarme", "Ganz viel Lieb dich sege"],
        correct: 1,
      },
    {
      emoji: "🎬",
      question: "Was ist mein Lieblingsfilm?",
      options: ["Inception", "Shutterisland", "Interstellar", "Fast and the Furious"],
      correct: 2,
    },
    {
      emoji: "💑",
      question: "Was ist mein Lieblings auto",
      options: ["nissan silvia s15", "toyota supra mk4", "nissan skyline gtr r34", "mazda rx 7"],
      correct: 2,
    },
  ],

  gift: {
    title: "Ein Wochenende in Basel",
    subtitle: "Für uns zwei — entspannen, geniessen, erleben 💑",
    location: "Basel, Schweiz",
    items: [
      { emoji: "🏨", text: "Übernachtung im 4★ Courtyard by Marriott Basel" },
      { emoji: "🌊", text: "Eintritt ins aquabasilea — grösste Wasserwelt der Schweiz" },
      { emoji: "🧖‍♀️", text: "Spa, Sauna & Wellness für zwei" },
      { emoji: "🍽️", text: '3-Gang-Menü "Chef\'s Choice" für zwei' },
      { emoji: "🥐", text: "All American Frühstücksbuffet im Hotel" },
    ],
    pdfPath: "/9107-1856-5583-7521.pdf",
  },

  finalMessage:
    "Ich liebe dich von ganzem Herzen. Auf viele weitere wunderschöne gemeinsame Momente! 🥂",
};

const EMOJI_HINTS = [
{ emoji: "🏨", text: "Wirds en materialistische gschenk ?" },
{ emoji: "🌊", text: "Isch Rushel überhaupt so kreativ" },
{ emoji: "🧖‍♀️", text: "Wömmer wo here?" },
{ emoji: "🍽️", text: 'Oder eifach go esse' },
{ emoji: "🥐", text: "oder machemer eifach nüt und löset finally mal dolder guetschii ih" },

];

const VALID_KEYWORDS = [
  'basel', 'hotel', 'spa', 'wellness', 'wasserpark',
  'aquabasilea', 'wochenende', 'übernacht', 'schweiz', 'courtyard',
];

// ============================================================
// QUIZ SCORE MESSAGES — je nach Resultat
// ============================================================
function getScoreResult(score, total) {
  if (score === total) return {
    emoji: '🌟',
    heading: 'Perfekt! Du kennsch mich ine und usse!',
    sub: "Ich bini SO glücklich dich z'ha, min Pingu 💝",
  };
  if (score >= total - 1) return {
    emoji: '💕',
    heading: 'Fast perfekt! Du kennsch mich richtig guet!',
    sub: 'Eine Frage danebe — aber du bisch trotzdem die Beschte! 😄',
  };
  if (score >= total - 2) return {
    emoji: '😊',
    heading: 'Guet gmacht! Du kennsch mich!',
    sub: 'Schritt für Schritt lernsch du mich immer besser kenne 😉',
  };
  if (score >= 1) return {
    emoji: '🥺',
    heading: 'Oj oj oj... kennsch du mich überhaupt?',
    sub: 'Zum Glück lieb ich dich trotzdem! 😂',
  };
  return {
    emoji: '😱',
    heading: 'NÜÜÜÜT richtig?! Kennsch du mich nöd?!',
    sub: 'Okeee... aber ich liebe dich trotzdem! 🤣',
  };
}

// ============================================================
// STAR FIELD BACKGROUND
// ============================================================
function StarField() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    // 12% of stars are gold-tinted
    const stars = Array.from({ length: 140 }, () => ({
      x:     Math.random(),
      y:     Math.random(),
      r:     Math.random() * 1.1 + 0.22,
      op:    Math.random() * 0.44 + 0.08,
      phase: Math.random() * Math.PI * 2,
      spd:   Math.random() * 0.35 + 0.08,
      gold:  Math.random() < 0.12,
    }));

    const draw = () => {
      const W = canvas.width;
      const H = canvas.height;
      ctx.clearRect(0, 0, W, H);
      const t = Date.now() * 0.001;

      stars.forEach(s => {
        const op = s.op * (0.48 + 0.52 * Math.sin(t * s.spd + s.phase));
        ctx.beginPath();
        ctx.arc(s.x * W, s.y * H, s.r, 0, Math.PI * 2);
        ctx.fillStyle = s.gold
          ? `rgba(212, 175, 106, ${op})`
          : `rgba(240, 228, 210, ${op})`;
        ctx.fill();

        // Soft glow on bright gold stars
        if (s.gold && op > 0.28) {
          ctx.beginPath();
          ctx.arc(s.x * W, s.y * H, s.r * 3.8, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(212, 175, 106, ${op * 0.07})`;
          ctx.fill();
        }
      });

      animId = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return <canvas ref={canvasRef} className="star-field" aria-hidden="true" />;
}

// ============================================================
// ROSE PETALS BACKGROUND
// ============================================================
function RosePetals() {
  const petals = useMemo(
    () =>
      Array.from({ length: 14 }, (_, i) => ({
        id:       i,
        left:     (i * 7.3 + 3) % 100,
        width:    7 + (i * 4) % 10,
        height:   11 + (i * 5) % 14,
        delay:    (i * 1.9) % 15,
        duration: 14 + (i * 2.3) % 10,
        rotate:   (i * 53) % 360,
        hue:      i % 3,
      })),
    []
  );

  const colors = [
    'rgba(196, 112, 128, 0.28)',
    'rgba(212, 175, 106, 0.20)',
    'rgba(232, 168, 184, 0.24)',
  ];

  return (
    <div className="rose-petals" aria-hidden="true">
      {petals.map(p => (
        <div
          key={p.id}
          className="petal"
          style={{
            left:              `${p.left}%`,
            width:             `${p.width}px`,
            height:            `${p.height}px`,
            backgroundColor:   colors[p.hue],
            animationDelay:    `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            transform:         `rotate(${p.rotate}deg)`,
          }}
        />
      ))}
    </div>
  );
}

// ============================================================
// CONFETTI
// ============================================================
function Confetti() {
  const pieces = useMemo(() => {
    const COLORS = ['#D4AF6A', '#F0CB7A', '#C47080', '#E8A8B8', '#E8C47A', '#A0C8B0', '#C88878'];
    return Array.from({ length: 88 }, (_, i) => ({
        id: i,
        color: COLORS[i % COLORS.length],
        left: (i * 1.14 + 0.5) % 100,
        delay: (i * 0.038) % 3.2,
        duration: 2.4 + (i * 0.065) % 2.8,
        size: 7 + (i % 5) * 2,
        radius: i % 3 === 0 ? '50%' : i % 3 === 1 ? '2px' : '0%',
        rotate: (i * 41) % 360,
      }));
  }, []);

  return (
    <div className="confetti-wrap" aria-hidden="true">
      {pieces.map((p) => (
        <div
          key={p.id}
          className="cpiece"
          style={{
            left: `${p.left}%`,
            backgroundColor: p.color,
            width: `${p.size}px`,
            height: `${p.size * (p.radius === '50%' ? 1 : 1.7)}px`,
            borderRadius: p.radius,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            transform: `rotate(${p.rotate}deg)`,
          }}
        />
      ))}
    </div>
  );
}

// ============================================================
// SCREEN 1 — INTRO
// ============================================================
function IntroScreen({ onNext }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 120);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`screen intro-screen ${show ? 'show' : ''}`}>
      <div className="inner center">
        <div className="big-emoji pulse" aria-hidden="true">💝</div>
        <div className="date-chip">{CONFIG.date} · Jahrestag</div>
        <h1 className="h-xl">
          Alles Gute
          <br />
          <span className="grad">zum Jahrestag</span>
        </h1>
        <p className="sub">
          Für meine wunderschöne
          <br />
          <span className="name-glow">{CONFIG.name} ✨</span>
        </p>
        <button className="btn btn-rose mt-xl" onClick={onNext}>
          Mein Geschenk öffnen 🎁
        </button>
      </div>
    </div>
  );
}

// ============================================================
// SCREEN 2 — LOVE LETTER
// ============================================================
function LetterScreen({ onNext }) {
  const [show, setShow] = useState(false);
  const [btnShow, setBtnShow] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShow(true), 80);
    const t2 = setTimeout(() => setBtnShow(true), 1700);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  return (
    <div className={`screen letter-screen ${show ? 'show' : ''}`}>
      <div className="inner">
        <div className="glass-card">
          <div className="letter-head">
            <span aria-hidden="true" className="letter-seal">💌</span>
            <h2>Ein Brief für dich</h2>
          </div>
          <div className="letter-divider">
            <span className="letter-divider-gem">✦</span>
          </div>
          <div className="letter-body">
            {CONFIG.loveLetterLines.map((line, i) =>
              line === '' ? <br key={i} /> : <p key={i}>{line}</p>
            )}
          </div>
          {btnShow && (
            <button className="btn btn-rose slide-up mt-xl" onClick={onNext}>
              Das Rätsel starten 🧩
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ============================================================
// SCREEN 3 — EMOJI PUZZLE
// ============================================================
function EmojiPuzzleScreen({ onNext }) {
  const [shown, setShown] = useState(0);
  const [inputReady, setInputReady] = useState(false);
  const [skipReady, setSkipReady] = useState(false);
  const [guess, setGuess] = useState('');
  const [feedback, setFeedback] = useState('');
  const [feedbackOk, setFeedbackOk] = useState(false);

  useEffect(() => {
    EMOJI_HINTS.forEach((_, i) => {
      setTimeout(() => {
        setShown(i + 1);
        if (i === EMOJI_HINTS.length - 1) {
          setTimeout(() => setInputReady(true), 500);
          setTimeout(() => setSkipReady(true), 5500);
        }
      }, (i + 1) * 950);
    });
  }, []);

  const handleGuess = () => {
    const g = guess.toLowerCase().trim();
    if (!g) return;
    const ok = VALID_KEYWORDS.some((k) => g.includes(k));
    if (ok) {
      setFeedback('🎉 Ja genau! Du bist so schlau!');
      setFeedbackOk(true);
      setTimeout(onNext, 1500);
    } else {
      setFeedback('Hmm... schau nochmal die Hinweise an 😄');
      setFeedbackOk(false);
      setTimeout(() => setSkipReady(true), 400);
    }
  };

  return (
    <div className="screen puzzle-screen show">
      <div className="inner">
        <h2 className="h-lg center">Was könnte es sein? 🤔</h2>
        <p className="sub center mb-lg">Schau dir die Hinweise an...</p>

        <div className="hints-list">
          {EMOJI_HINTS.map((h, i) => (
            <div
              key={i}
              className={`hint-row ${i < shown ? 'hint-in' : 'hint-out'}`}
              style={{ transitionDelay: `${i * 0.04}s` }}
            >
              <span className="hint-em" aria-hidden="true">{h.emoji}</span>
              <span className="hint-txt">{h.text}</span>
            </div>
          ))}
        </div>

        {inputReady && (
          <div className="guess-area slide-up">
            <div className="guess-row">
              <input
                type="text"
                className="guess-input"
                placeholder="Dein Tipp..."
                value={guess}
                onChange={(e) => setGuess(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleGuess()}
                autoComplete="off"
                autoCapitalize="none"
              />
              <button className="btn-icon" onClick={handleGuess} aria-label="Absenden">
                ✓
              </button>
            </div>
            {feedback && (
              <p className={`feedback ${feedbackOk ? 'fb-ok' : 'fb-hint'}`}>{feedback}</p>
            )}
          </div>
        )}

        {skipReady && (
          <button className="btn btn-ghost slide-up mt-md" onClick={onNext}>
            Lösung enthüllen 🎊
          </button>
        )}
      </div>
    </div>
  );
}

// ============================================================
// SCREEN 4 — LOVE QUIZ
// ============================================================
function QuizScreen({ onNext }) {
  const [show, setShow] = useState(false);
  const [qIdx, setQIdx] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 80);
    return () => clearTimeout(t);
  }, []);

  const q = CONFIG.quizQuestions[qIdx];
  const total = CONFIG.quizQuestions.length;

  const handleSelect = (idx) => {
    if (selected !== null) return;
    setSelected(idx);
    if (idx === q.correct) setScore((s) => s + 1);
  };

  const handleNext = () => {
    if (qIdx < total - 1) {
      setQIdx((i) => i + 1);
      setSelected(null);
    } else {
      setDone(true);
      setTimeout(onNext, 2000);
    }
  };

  return (
    <div className={`screen quiz-screen ${show ? 'show' : ''}`}>
      <div className="inner">
        {!done ? (
          <>
            <div className="quiz-top center">
              <div className="progress-dots">
                {CONFIG.quizQuestions.map((_, i) => (
                  <span key={i} className={`dot ${i <= qIdx ? 'dot-on' : ''}`} />
                ))}
              </div>
              <h2 className="h-lg">Kennst du mich? 💕</h2>
              <p className="counter">{qIdx + 1} / {total}</p>
            </div>

            <div className="glass-card question-card">
              <div className="q-em" aria-hidden="true">{q.emoji}</div>
              <h3 className="q-text">{q.question}</h3>
              <div className="opts-grid">
                {q.options.map((opt, idx) => (
                  <button
                    key={idx}
                    className={`opt-btn ${
                      selected === null
                        ? ''
                        : idx === q.correct
                        ? 'opt-correct'
                        : idx === selected
                        ? 'opt-wrong'
                        : 'opt-dim'
                    }`}
                    onClick={() => handleSelect(idx)}
                    disabled={selected !== null}
                  >
                    {opt}
                  </button>
                ))}
              </div>
              {selected !== null && (
                <button className="btn btn-rose slide-up mt-lg" onClick={handleNext}>
                  {qIdx < total - 1 ? 'Nächste Frage →' : 'Zum Geschenk! 🎁'}
                </button>
              )}
            </div>
          </>
        ) : (
          <div className="quiz-done center slide-up">
            {(() => {
              const r = getScoreResult(score, total);
              return (
                <>
                  <div className="score-em" aria-hidden="true">{r.emoji}</div>
                  <div className="score-num grad">{score}/{total}</div>
                  <h2 className="h-lg">{r.heading}</h2>
                  <p className="sub mt-sm">{r.sub}</p>
                </>
              );
            })()}
          </div>
        )}
      </div>
    </div>
  );
}

// ============================================================
// SCREEN 5 — GIFT REVEAL
// ============================================================
function RevealScreen({ onNext }) {
  const [show, setShow] = useState(false);
  const [itemsIn, setItemsIn] = useState(false);
  const [btnIn, setBtnIn] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShow(true), 80);
    const t2 = setTimeout(() => setItemsIn(true), 850);
    const t3 = setTimeout(() => setBtnIn(true), 2300);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  return (
    <div className={`screen reveal-screen ${show ? 'show' : ''}`}>
      <Confetti />
      <div className="inner center reveal-inner">
        <h1 className="reveal-title">🎉 Dein Geschenk!</h1>
        <p className="reveal-sub">{CONFIG.gift.subtitle}</p>

        <div className="glass-card gift-card">
          <h2 className="gift-name grad">{CONFIG.gift.title}</h2>
          <p className="gift-loc">📍 {CONFIG.gift.location}</p>
          <div className={`gift-items ${itemsIn ? 'items-in' : ''}`}>
            {CONFIG.gift.items.map((item, i) => (
              <div
                key={i}
                className="gift-item"
                style={{ animationDelay: `${i * 0.12}s` }}
              >
                <span aria-hidden="true">{item.emoji}</span>
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>

        {btnIn && (
          <button className="btn btn-rose btn-lg slide-up mt-xl" onClick={onNext}>
            Gutschein anzeigen 📄
          </button>
        )}
      </div>
    </div>
  );
}

// ============================================================
// SCREEN 6 — VOUCHER
// ============================================================
function VoucherScreen() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`screen voucher-screen ${show ? 'show' : ''}`}>
      <div className="inner center">
        <div className="voucher-heart pulse" aria-hidden="true">💝</div>
        <h1 className="h-xl grad">
          Ich liebe dich,
          <br />
          {CONFIG.name}!
        </h1>
        <p className="sub mt-sm">{CONFIG.finalMessage}</p>

        <div className="glass-card voucher-card mt-xl">
          <div className="vchr-icon" aria-hidden="true">🎟️</div>
          <h3>Dein Gutschein</h3>
          <p className="vchr-desc">Basel Wellness Wochenende · 2 Personen</p>
          <a
            href={CONFIG.gift.pdfPath}
            download="Jahrestag-Gutschein.pdf"
            className="btn btn-rose btn-block mt-lg"
          >
            📥 Gutschein herunterladen
          </a>
          <a
            href={CONFIG.gift.pdfPath}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-ghost btn-block mt-sm"
          >
            👁️ Im Browser anzeigen
          </a>
        </div>

        <div className="final-stars" aria-hidden="true">⭐ ✨ 💫 ✨ ⭐</div>
        <p className="final-tag">Alles Gute zum Jahrestag! 🥂</p>
      </div>
    </div>
  );
}

// ============================================================
// APP ROOT
// ============================================================
const SCREENS = ['intro', 'letter', 'emoji', 'quiz', 'reveal', 'voucher'];

export default function App() {
  const [idx, setIdx] = useState(0);
  const [fading, setFading] = useState(false);

  const next = useCallback(() => {
    if (fading || idx >= SCREENS.length - 1) return;
    setFading(true);
    setTimeout(() => {
      setIdx((i) => i + 1);
      setFading(false);
    }, 320);
  }, [fading, idx]);

  const screen = SCREENS[idx];

  return (
    <div className={`app ${fading ? 'app-out' : ''}`}>
      <StarField />
      <RosePetals />
      {screen === 'intro'   && <IntroScreen key="intro" onNext={next} />}
      {screen === 'letter'  && <LetterScreen key="letter" onNext={next} />}
      {screen === 'emoji'   && <EmojiPuzzleScreen key="emoji" onNext={next} />}
      {screen === 'quiz'    && <QuizScreen key="quiz" onNext={next} />}
      {screen === 'reveal'  && <RevealScreen key="reveal" onNext={next} />}
      {screen === 'voucher' && <VoucherScreen key="voucher" />}
    </div>
  );
}
